<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Group</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :descWidth="100" :codes="classGroups" v-model="classGroup" /> </span>

				<em class="lt_text">Dept A</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :width="50" :descWidth="70" :codes="deptAs" v-model="deptA" /> </span>

				<em class="lt_text">Dept B</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :width="50" :descWidth="70" :codes="deptBs" v-model="deptB" /> </span>

				<em class="lt_text">Category</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :nameWidth="500" :codes="categories" :showDesc="false" v-model="category" /> </span>

				<span class="int_type mgr_5">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<em class="lt_text">On Hand</em>
				<span class="int_type">
					<select v-model="on_hand_condition" class="tbl_select sm_int">
						<option :value="null"></option>
						<option value="less_than">&lt;</option>
						<option value="equal">=</option>
						<option value="greater_than">&gt;</option>
					</select>
				</span>
				<span class="int_type mgr_15 " style="width:60px;">
					<currency-input type="text" class="al_right" :precision="0" v-model="on_hand_quantity" autocomplete="off" />
				</span>
				<span class="int_type mgr_5">
					<input type="text" v-model="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_small_tbl">
				<table id="item_list" class="list_tbl tbl_pointer">
					<thead>
						<tr>
							<th style="text-align:center;width:2%;"></th>
							<!-- <th style="text-align:center;width:10%;">Class Code</th> -->
							<th style="text-align:center;width:10%;">{{ headers.class }} Code</th>
							<th style="text-align:center;width:10%;">WH Code</th>
							<th style="text-align:center;">{{ headers.class }} Name</th>
							<!-- <th style="text-align:center">Description</th> -->
							<th style="text-align:center;width:20%;">Group</th>
							<!-- <th style="text-align:center;width:3%;">A</th>
							<th style="text-align:center;width:3%;">B</th>
							<th style="text-align:center;width:3%;">Cat.</th> -->
							<th style="text-align:center;width:5%;">Closed</th>
							<th style="text-align:center;width:5%;">Active</th>
							<th style="text-align:center;width:5%;">Items</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="item in itemClasses" v-bind:key="item.code" v-bind:class="{ on: item.code == selectedItemClass.code }" @click="selectRow(item)">
							<td class="al_center"><img v-img v-if="item.image_file_name" :src="getImageUrl(item.image_file_name)" alt="File Not Found" style="cursor: zoom-in;max-height:20px;max-width:15px;height:auto;width:auto;" /></td>
							<td>
								<font :color="item.so_blocked ? 'red' : 'black'">{{ item.code }}</font>
							</td>
							<td>
								<font :color="item.so_blocked ? 'red' : 'black'">{{ item.wh_code }}</font>
							</td>
							<td class="truncate">
								<font :color="item.so_blocked ? 'red' : 'black'"
									><span :title="item.name">{{ item.name }}</span></font
								>
							</td>
							<!-- <td class="truncate">
								<span :title="item.description">{{ item.description }}</span>
							</td> -->
							<td class="truncate">
								<span :title="item.class_group_name">{{ item.class_group_name }}</span>
							</td>
							<!-- <td>{{ item.dept_a_code }}</td>
							<td>{{ item.dept_b_code }}</td>
							<td>{{ item.category_code }}</td> -->
							<td style="text-align:center;">{{ item.closed_yn }}</td>
							<td style="text-align:center;">{{ item.active_yn }}</td>
							<td style="text-align:right;">{{ item.item_count }}</td>
						</tr>
					</tbody>
				</table>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
			</div>

			<div class="right_big_tbl">
				<h4 class="inner_h5">Inventory Adjustment Entry</h4>

				<table id="item_list" class="list_tbl tbl_pointer" border="0">
					<thead>
						<tr>
							<th style="text-align:center;width:2%;"></th>
							<th style="text-align:center;width:18%">Item Code</th>
							<th style="text-align:center">Name</th>
							<th style="text-align:center;width:15%">Color</th>
							<th style="text-align:center;width:8%;">Curr. Qty.</th>
							<th style="text-align:center;width:9%;">Qty. to Adjust</th>
							<th style="text-align:center;width:9%;">New Qty</th>

							<!-- <th style="text-align:center;width:3%;"><div class="th-text">Active</div></th> -->
						</tr>
					</thead>

					<tbody>
						<tr v-for="(item, index) in items" v-bind:key="item.item_id">
							<td class="al_center"><img v-img v-if="item.image_file_name" :src="getImageUrl(item.image_file_name)" alt="File Not Found" style="cursor: zoom-in;max-height:20px;max-width:20px;height:auto;width:auto;" /></td>
							<td class="al_left">{{ item.item_code }}</td>
							<td class="al_left truncate">{{ item.name }}</td>
							<td class="al_left">{{ item.color_code }}</td>
							<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									:ref="'adjust' + index"
									v-model="item.adjust_quantity"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									:precision="0"
									@keydown.enter.prevent="goTo('adjust', index + 1)"
									@keydown.down.prevent="goTo('adjust', index + 1)"
									@keydown.up.prevent="goTo('adjust', index - 1)"
									@input="calNewQty(item)"
								/>
							</td>
							<td class="al_right">
								<currency-input
									type="text"
									:ref="'new_on_hand' + index"
									v-model="item.new_on_hand"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									:precision="0"
									:style="item.on_hand != item.new_on_hand ? 'border:1px solid red' : 'border:1px solid #ddd'"
									@keydown.enter.prevent="goTo('new_on_hand', index + 1)"
									@keydown.down.prevent="goTo('new_on_hand', index + 1)"
									@keydown.up.prevent="goTo('new_on_hand', index - 1)"
									@input="calAdjustQty(item)"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="view_bottom_bt" style="margin-top:10px">
					<a v-if="modifiable" href="javascript:;" class="search_bt" @click="save()">Save</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectItemClassList } from '@/api/item/class.js';
import { apiSelectItemList } from '@/api/item/master';
import { apiAdjustBatch } from '@/api/item/inventory.js';
import { toCurrency } from '@/utils/etc.js';
//import { headerClass } from '@/api/headers.js';
import _ from 'lodash';
import Paging from '@/components/common/Paging';
import CodeSelect from '@/components/common/CodeSelect';
//import ItemDetail from '@/components/common/ItemDetail';
import '@/assets/css/table_box.css';
//import JqxGrid from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue';

export default {
	data: function() {
		return {
			classGroups: [],
			deptAs: [],
			deptBs: [],
			categories: [],
			locations: [],
			colors: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			classGroup: null,
			deptA: null,
			deptB: null,
			category: null,

			keyword: '',
			closed_yn: 'N',
			active_yn: 'Y',
			hot_yn: '',
			new_yn: '',
			discount_yn: '',
			mode: null,
			on_hand_condition: null,
			on_hand_quantity: 0,

			itemClasses: [],
			selectedItemClass: {},

			itemClass: {},

			fobs: [],
			items: [],
			new_item: {},

			selectedItem: {},
			modalName: '',
			showModal: false,

			colorCodes: [],
			bool_hot: false,
			bool_new: false,
			// itemDataAdapter: null, //new jqx.dataAdapter(this.source),
			// itemColumns: [
			// 	{ text: 'First Name', columntype: 'textbox', datafield: 'firstname', width: 200 },
			// 	{ text: 'Last Name', datafield: 'lastname', columntype: 'textbox', width: 200 },
			// ],
			imageOpen: false,
			imageUrl: null,

			extraImages: [],
			curIndex: -1,

			fob_cost_link: null,
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		CodeSelect,
	},
	methods: {
		calNewQty(item) {
			item.new_on_hand = item.on_hand + item.adjust_quantity;
			// if (item.adjust_quantity) item.new_on_hand = item.on_hand + item.adjust_quantity;
			// else item.new_on_hand = null;
		},
		calAdjustQty(item) {
			item.adjust_quantity = item.new_on_hand - item.on_hand;
			// if (item.new_on_hand) item.adjust_quantity = item.new_on_hand - item.on_hand;
			// else item.adjust_quantity = null;
		},
		getImageUrl(image_file_name) {
			//var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + it.image_file_name;
			var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + image_file_name;
			return url;
		},
		goTo(colType, index) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					var comp = this.$refs[colType + index][0].$el; //.select();
					comp.select();
				}
			});
		},

		openImage(index, url) {
			//console.log(index, url);
			this.curIndex = index;
			this.imageUrl = url;
			this.modalName = 'Image';
			this.showModal = true;
		},

		search() {
			this.page_no = 1;
			this.selectItemClasses();
		},
		reset() {
			this.page_no = 1;
			this.closed_yn = 'N';
			this.active_yn = 'Y';
			this.keyword = '';
			//this.dlClassGroup.unSelectOption();
			this.classGroup = null;
			this.deptA = null;
			this.deptB = null;
			this.category = null;
		},
		async selectItemClasses() {
			this.mode = 'detail';
			this.itemClass = {};
			this.selectedItemClass = {};

			var param = {
				class_group: this.classGroup,
				dept_a: this.deptA,
				dept_b: this.deptB,
				category: this.category,
				keyword: this.keyword,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				active_yn: this.active_yn,
				closed_yn: this.closed_yn,

				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,
			};

			if (this.keyword) {
				param.active_yn = 'A';
				param.closed_yn = 'A';
			}

			const { data } = await apiSelectItemClassList(param);

			//console.log(data);
			this.itemClasses = data.itemClassList;
			this.list_count = data.list_count;

			this.items = [];

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			//if (this.itemClasses.length > 0) this.selectRow(this.itemClasses[0]);
		},
		async save() {
			//console.log(this.items.filter(i => i.new_on_hand != i.on_hand));
			var item_data = [];
			this.items.forEach(function(item) {
				if (item.new_on_hand != item.on_hand) {
					var param_item = {
						item_id: item.item_id,
						before_quantity: item.on_hand,
						after_quantity: item.new_on_hand,
					};

					if (!param_item.before_quantity) param_item.before_quantity = 0;
					if (!param_item.after_quantity) param_item.after_quantity = 0;

					item_data.push(param_item);
				}
			});

			if (item_data.length == 0) {
				this.$toast.error('Nothing to adjust');
				return;
			}

			var param = {
				adjust_reason: 'adjust',
				items: item_data,
			};
			//console.log(this.selectedItemClass.code, param);

			// var dummy = true;
			// if (dummy) return;

			const { data } = await apiAdjustBatch(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectItems(this.selectedItemClass.code);
			} else {
				this.$toast.error(data.msg);
			}
		},
		setItem(item) {
			Object.assign(this.selectedItem, item);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectItemClasses();
		},
		selectRow(item) {
			this.selectedItemClass = item;
			this.itemClass = _.cloneDeep(item);
			this.selectItems(this.itemClass.code);
		},

		async selectItems(class_code) {
			const { data } = await apiSelectItemList({
				class_code: class_code,
				active_yn: 'Y',
				paging_yn: 'N',
				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,
				report: true,
			});

			//console.log(data);
			this.items = data.itemList;

			this.$forceUpdate();
			//console.log(this.items);
		},
		async index() {
			const { data } = await apiIndex();

			this.classGroups = data.classGroupList;
			this.deptAs = data.deptAList;
			this.deptBs = data.deptBList;
			this.categories = data.categoryList;
			this.locations = data.locationList;
			this.colors = data.colorList;

			// this.colorCodes = [];
			// var vm = this;
			// var i = 0;
			// this.colors.forEach(c => {
			// 	i++;
			// 	if (i < 10) vm.colorCodes.push(c.code);
			// });
			//console.log(this.colors);
			//console.log(this.colorCodes);

			//this.setDlOptions(this.dlClassGroup, data.classGroupList);
		},
		keyArrow(dir) {
			//console.log(dir);
			if (dir == 1) {
				if (this.curIndex == -1 && this.extraImages.length > 0) {
					this.openImage(0, this.getImageUrl(this.extraImages[0].image_file_name));
				} else if (this.curIndex < this.extraImages.length - 1) {
					this.openImage(this.curIndex + 1, this.getImageUrl(this.extraImages[this.curIndex + 1].image_file_name));
				}
			} else if (dir == -1) {
				if (this.curIndex == 0) {
					this.openImage(-1, this.getImageUrl(this.itemClass.image_file_name));
				} else if (this.curIndex > 0) {
					this.openImage(this.curIndex - 1, this.getImageUrl(this.extraImages[this.curIndex - 1].image_file_name));
				}
			}
		},
		getCurrencyForamt(inputValue) {
			return toCurrency(inputValue);
		},
	},
	created() {
		//this.$store.sideIndex = 1;
		this.$store.commit('setSideIndex', 1);
		//this.$store.selectedMenu = 'nav_li_1';
		this.$store.commit('setSelectedMenu', 'nav_li_stock_adjust');
		this.$store.commit('setSubTitle', 'Item -> Stock Adjustment');

		this.index();
		this.selectItemClasses();

		window.addEventListener('keydown', e => {
			//console.log(e.key);
			if (this.showModal && this.modalName == 'Image') {
				if (e.key == 'ArrowLeft') {
					//left : 37, right : 39
					this.keyArrow(-1);
				} else if (e.key == 'ArrowRight') {
					this.keyArrow(1);
				}
			}
		});

		//console.log(this.generatedata(10));

		// eslint-disable-next-line no-undef
		// this.itemDataAdapter = new jqx.dataAdapter({
		// 	localdata: [
		// 		{ firstname: 'Gyujung', lastname: 'Kim' },
		// 		{ firstname: 'fdsfsd', lastname: 'fjdslf' },
		// 	],
		// 	datatype: 'json',
		// 	datafileds: [
		// 		{ name: 'firstname', type: 'string' },
		// 		{ name: 'lastname', type: 'string' },
		// 	],
		// 	//id: 'id',
		// });
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
